







































import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePaginatorHoc from '@/components/base/BasePaginatorHoc.vue';
import ContentWrapper from '@/components/ContentWrapper.vue';
import SiteWrapper from '@/components/SiteWrapper.vue';
import { ModuleSortColumns } from '@/jbi-shared/types/jtms.types';
import { SortOrder } from '@/jbi-shared/types/search.types';
import { Vue, Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import {
  ApiState,
  PaginatorSpecs,
  SortEventData
} from '@/store/types/general.types';
import { RootState } from '@/store/store';
import { initialFilterState } from '@/store/modules/jtms/module/module.const';
import {
  ModuleFilterOptions,
  ModuleQueryParams,
  PaginatedModules
} from '@/store/modules/jtms/module/module.types';
import ModuleList from './components/ModuleList.vue';
import ModuleSearch from './ModuleSearch.vue';
import CreateModuleModal from './CreateModuleModal.vue';
import { ModuleResponseDTO } from '@/jbi-shared/dto/jtms.dtos';
import ActivateArchiveModuleConfirmationModal from './ActivateArchiveModuleConfirmationModal.vue';

@Component({
  components: {
    BaseLoading,
    SiteWrapper,
    ContentWrapper,
    BasePaginatorHoc,
    ModuleSearch
  }
})
export default class JTMSModule extends Vue {
  moduleFilterParams: ModuleFilterOptions = initialFilterState();
  queryParamsForCourseLicenseTemplates: ModuleQueryParams = {
    ...this.moduleFilterParams,
    sortOrder: SortOrder.ASC,
    sortColumn: ModuleSortColumns.NAME,
    page: 1,
    limit: 50
  };

  @Action('module/getPaginatedModules')
  getPaginatedCourseLicenseTemplate!: (
    payload: ModuleQueryParams
  ) => Promise<PaginatedModules>;

  @State((state: RootState) => state.module.paginatedModules)
  modules!: PaginatedModules;

  @State((state: RootState) => state.module.apiState.getPaginatedModules)
  getPaginatedModulesApiState!: ApiState;

  get isLoading() {
    return this.getPaginatedModulesApiState.loading;
  }

  get items() {
    if (this.modules) {
      return this.modules.items;
    }

    return [];
  }

  get totalCount() {
    if (this.modules) {
      return this.modules.totalItems;
    }

    return 0;
  }

  get ModuleList() {
    return ModuleList;
  }

  created() {
    this.getPaginatedCourseLicenseTemplate(
      this.queryParamsForCourseLicenseTemplates
    );
  }

  openCreateModuleModal() {
    this.$buefy.modal.open({
      parent: this,
      component: CreateModuleModal,
      hasModalCard: true,
      trapFocus: true,
      events: {
        refreshPage: () => {
          this.refreshList();
        }
      }
    });
  }

  openActivateModuleConfirmationModal(moduleToActivate: ModuleResponseDTO) {
    this.$buefy.modal.open({
      parent: this,
      component: ActivateArchiveModuleConfirmationModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        module: moduleToActivate,
        isActivateModule: true
      },
      events: {
        refreshPage: () => {
          this.refreshList();
        }
      }
    });
  }

  openArchiveModuleConfirmationModal(moduleToArchive: ModuleResponseDTO) {
    this.$buefy.modal.open({
      parent: this,
      component: ActivateArchiveModuleConfirmationModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        module: moduleToArchive,
        isActivateModule: false
      },
      events: {
        refreshPage: () => {
          this.refreshList();
        }
      }
    });
  }

  refreshList() {
    this.getPaginatedCourseLicenseTemplate(
      this.queryParamsForCourseLicenseTemplates
    );
  }

  modifyQueryParams<T>(paramsMap: Map<string, T>) {
    for (const [key, value] of paramsMap.entries()) {
      if (key in this.queryParamsForCourseLicenseTemplates) {
        // Use type assertion to safely assign the value
        (this.queryParamsForCourseLicenseTemplates as Record<string, any>)[
          key
        ] = value;
      }
    }
  }

  handleFilter() {
    const map = new Map();
    map.set('page', 1);

    // Dynamically map each filter to the query params
    for (const [key, value] of Object.entries(this.moduleFilterParams)) {
      if (key === 'status') {
        map.set(key, value.toUpperCase());
      } else {
        map.set(key, value);
      }
    }

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handleResetFilter() {
    this.moduleFilterParams = initialFilterState();
  }

  handlePaginator(paginator: PaginatorSpecs) {
    const map = new Map();
    map.set('limit', paginator.perPage);
    map.set('page', paginator.page);

    this.modifyQueryParams(map);
    this.refreshList();
  }

  handleSort(data: SortEventData) {
    const map = new Map();
    map.set('sortColumn', data.sortColumn);
    map.set('sortOrder', data.sortOrder);

    this.modifyQueryParams(map);
    this.refreshList();
  }
}
